import { render, staticRenderFns } from "./BaseRowDetail.vue?vue&type=template&id=540c4720&scoped=true"
import script from "./BaseRowDetail.vue?vue&type=script&lang=js"
export * from "./BaseRowDetail.vue?vue&type=script&lang=js"
import style0 from "./BaseRowDetail.vue?vue&type=style&index=0&id=540c4720&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540c4720",
  null
  
)

export default component.exports